import React, { useEffect, useState, useMemo } from "react"
import { motion } from 'framer-motion'
import { useSelector } from "react-redux"
import API from "../../Common/API"
import { useTranslation } from "react-i18next"
import PlanDetailsLoader from "../../Components/Loaders/PlanDetailsLoader"
import dayjs from 'dayjs';
import { useHistory } from "react-router-dom"

const PlanDetails = () => {
    const [planDetails, setPlanDetails] = useState()
    const [loading, setLoading] = useState(true)
    const countApi = useSelector((state) => state.auth.countApi)
    const { t } = useTranslation()
    const history = useHistory()

    useEffect(() => {
        setLoading(true)
        API.get('/plans/getSubscribedPlanDetails').then((planRes) => {
            setPlanDetails(planRes.data.data)
            setLoading(false)
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }, [countApi])

    const validityInfo = useMemo(() => {
        if (!planDetails?.planValidityDate) return null;

        const validityDate = dayjs(planDetails.planValidityDate);
        const today = dayjs();
        const daysLeft = validityDate.diff(today, 'day');
        const isExpiringSoon = daysLeft <= 15;
        const formattedDate = validityDate.format('DD/MM/YYYY');

        return { daysLeft, formattedDate, isExpiringSoon };
    }, [planDetails]);

    return (
        <>
            {
                loading ? (
                    <PlanDetailsLoader />
                ) : planDetails ? (
                    <motion.div className="w-full h-full bg-white rounded-lg flex flex-col">
                        <p className="flex flex-row w-full items-center font-bold text-md my-2 md:hidden block justify-center">Account Plan Details</p>
                        <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start">
                            <p className="text-black font-bold  text-sm md:text-md">{t('Plan')}</p>&nbsp;:&nbsp;
                            <p className="text-primeColor font-bold text-xl">{planDetails.planId.planName}</p>
                        </motion.div>
                        <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start">
                            <p className="text-black font-bold  text-sm md:text-md">{t('Total Count')}</p>&nbsp;:&nbsp;
                            <p className="text-primeColor font-bold text-xl">{planDetails.planId.downloadLimit - planDetails.downloadCount}</p>
                        </motion.div>
                        <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start">
                            <p className="text-black font-bold  text-sm md:text-md">{t('Downloaded Count')}</p>&nbsp;:&nbsp;
                            <p className="text-primeColor font-bold text-xl">{planDetails.downloadCount}</p>
                        </motion.div>

                        {validityInfo && (
                            <motion.div className="flex flex-row w-full items-center px-2 py-2 justify-start gap-2 flex-wrap">
                                <p className="text-black font-bold  text-sm md:text-md">{t('Valid Upto')}</p>
                                <span>:</span>
                                <p className={`font-bold text-xl ${validityInfo.isExpiringSoon ? 'text-red-600' : 'text-primeColor'}`}>
                                    {validityInfo.formattedDate}
                                </p>
                                <p className={`text-sm font-medium ${validityInfo.isExpiringSoon ? 'text-red-600' : 'text-gray-700'}`}>
                                    ({validityInfo.daysLeft} {t('days left')})
                                </p>
                                {validityInfo.isExpiringSoon && (
                                    <button className="ml-4 px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition">
                                        {t('Renew Now')}
                                    </button>
                                )}
                            </motion.div>
                        )}
                    </motion.div>
                ) : (
                    <motion.div className="w-full py-2 px-2 items-center justify-center h-48 bg-white flex flex-col">
                        <motion.div className="text-primeColor text-md justify-center">
                            {t('Subscribe and unlock all the features')}
                        </motion.div>
                        <motion.div className="bg-primeColor text-white cursor-pointer font-bold w-fit px-2 py-2 rounded-lg" onClick={()=>history.push('/subscription')}>
                            {t('Subscribe')}
                        </motion.div>
                    </motion.div>
                )
            }
        </>
    )
}

export default PlanDetails